module.exports = __webpack_public_path__ + "static/avatar-2-74a1a477a05b29229de41f904ee8b6ae.png";